import React from "react"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"

export default function ToolbarStylesButton(state: any, props: any) {
    const {isCode, isStrikethrough, isSubscript, isSuperscript} = props.menuParams

    const isSelected = isCode || isStrikethrough || isSubscript || isSuperscript

    const classes = Classes("flex-row-center-center", {
        'show-popover': state.showPopover
    })

    const iconClasses = Classes("icon ui5-ico-16 editor-i5-style-more", {
        'selected': isSelected
    })

    return (
        <ControlButtonStandard className={classes} isSelected={isSelected}>
            <div className={iconClasses}/>
        </ControlButtonStandard>
    )
}